<template>
	<div>
		<grid-layout
			:layout.sync="layout"
			style="position: absolute !important; height: 100% !important; width: 100% !important; top: 0; left: 0"
			:col-num="100"
			:row-height="1"
			:is-draggable="true"
			:is-resizable="false"
			:vertical-compact="false"
			:use-css-transforms="true"
		>
			<grid-item
				v-for="(item, index) in layout"
				:key="index"
				style="width: 45%; height: max-content"
				:static="item.static"
				:x="item.x"
				:y="item.y"
				:w="item.w"
				:h="item.h"
				:i="item.i"
				dragIgnoreFrom=".box-card, .dragArea"
				drag-allow-from=".vue--handle"
			>
				<div
					class="grid-content bg-purple md-elevation-4"
					style="position: fixed; width: inherit; background-color: white; padding: 20px; border-radius: 10px"
				>
					<div
						class="vue--handle"
						style="width: 100%; height: auto; background-color: white; margin-bottom: 10px; padding: 10px"
					>
						<md-button v-if="!expanded" class="md-icon-button" @click="expanded = !expanded">
							<md-icon>arrow_drop_down</md-icon>
						</md-button>
						<md-button v-else class="md-icon-button" @click="expanded = !expanded">
							<md-icon>arrow_drop_up</md-icon>
						</md-button>
						<span class="md-headline">Componenti</span>
						<el-button type="danger" style="height: min-content; float: right" @click="closeEditor"
							>X</el-button
						>
					</div>
					<el-collapse-transition>
						<div v-if="expanded">
							<div style="width: 100%">
								<el-input
									placeholder="Cerca elemento..."
									v-model="searchEl"
									prefix-icon="el-icon-search"
								></el-input>
							</div>

							<div v-if="loading">
								<div
									style="
										display: flex;
										align-content: center;
										align-items: center;
										align-self: center;
										flex-direction: column;
									"
								>
									<div
										style="
											display: flex;
											align-content: center;
											align-items: center;
											align-self: center;
											flex-direction: row;
										"
									>
										<md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
									</div>
								</div>
							</div>

							<div v-else>
								<div
									style="
										width: 100%;
										height: auto;
										background-color: white;
										margin-bottom: 10px;
										padding: 10px;
									"
								>
									<md-button
										@click="expandedDefault = !expandedDefault"
										style="text-transform: none; font-weight: 400"
									>
										<md-icon>{{ expandedDefault ? "arrow_drop_down" : "arrow_drop_up" }}</md-icon>
										<span>{{ $t("base-elements") }}</span>
									</md-button>
								</div>
								<el-collapse-transition>
									<div v-if="expandedDefault && list">
										<draggable
											style="max-height: 30vh; overflow-y: scroll; margin-top: 10px"
											v-model="list"
											class="dragArea list-group"
											:options="ListOptions"
											:empty-insert-threshhold="500"
											:clone="clone"
											:scroll-sensitivity="200"
											:force-fallback="true"
										>
											<el-card
												v-if="
													element.name
														.toLowerCase()
														.replace(/\s+/g, '')
														.includes(searchEl.toLowerCase())
												"
												class="box-card"
												style="
													width: 45%;
													display: inline-block;
													margin: 5px;
													border-radius: 15px;
												"
												@dblclick.native="dblClick(element)"
												v-for="element in list"
												:key="element.id"
											>
												<!--												<md-icon class="handle">extension</md-icon>-->
												{{ element.name }}
											</el-card>
										</draggable>
									</div>
								</el-collapse-transition>

								<div
									style="
										width: 100%;
										height: auto;
										background-color: white;
										margin-bottom: 10px;
										padding: 10px;
									"
								>
									<md-button
										@click="expandedSave = !expandedSave"
										style="text-transform: none; font-weight: 400"
									>
										<md-icon>{{ expandedSave ? "arrow_drop_down" : "arrow_drop_up" }}</md-icon>
										<span>{{ $t("saved-elements") }}</span>
									</md-button>
								</div>
								<el-collapse-transition>
									<div v-if="expandedSave && listSaved">
										<draggable
											style="max-height: 30vh; overflow-y: scroll; margin-top: 10px"
											v-model="listSaved"
											class="dragArea list-group"
											:options="ListOptions"
											:clone="clone"
											:empty-insert-threshhold="500"
											:scroll-sensitivity="200"
											:force-fallback="true"
										>
											<el-card
												v-if="
													element.name
														.toLowerCase()
														.replace(/\s+/g, '')
														.includes(searchEl.toLowerCase())
												"
												class="box-card"
												style="
													width: 45%;
													display: inline-block;
													margin: 5px;
													border-radius: 15px;
												"
												@dblclick.native="dblClick(element)"
												v-for="element in listSaved"
												:key="element.id"
											>
												<!--												<md-icon class="handle">extension</md-icon>-->
												{{ element.name }}
												<el-tooltip v-if='element.wiki' style='border:none; width: 25px' class="item" effect="dark" :content="element.wiki" placement="top">
													<md-icon>help_outline</md-icon>
												</el-tooltip>
												<!--												<md-button style="z-index: auto;margin-top: -10px; float: right" class="md-icon-button" @click="deleteCustomEL(element.ref_id)">-->
												<!--													<md-icon class="handle" >delete</md-icon>-->
												<!--												</md-button>-->
											</el-card>
										</draggable>
									</div>
								</el-collapse-transition>
							</div>
						</div>
					</el-collapse-transition>
				</div>
			</grid-item>
		</grid-layout>
	</div>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import { clone, cloneAt } from "@/modules/builder/utils/utils"
import draggable from "vuedraggable"
import VueGridLayout from "vue-grid-layout"

export default {
	name: "builder-element",
	data() {
		return {
			layout: [{ x: 0, y: 0, w: 1, h: 1, i: "0", static: false }],
			expanded: true,
			expandedDefault: true,
			expandedSave: false,
			searchEl: "",
			loading: true
		}
	},
	created() {
		this.loadList().then(() => {
			//si c'è un timer, altrimenti è troppo veloce
			setTimeout(() => {
				this.loading = false
			}, 500)
		})
	},
	computed: {
		selected_node() {
			var ind = this.nodes.findIndex(i => i.id == this.selected_node_id)
			return this.node_value(ind)
		},
		...mapGetters({
			list: "builder/list",
			nodes: "flowchart/nodes",
			listSaved: "builder/listSaved",
			toinsert: "builder/toinsert",
			toedit: "builder/toedit",
			showInsert: "builder/showInsert",
			showEdit_state: "builder/showEdit",
			selectOptions: "builder/selectOptions",
			selected_node_id: "flowchart/showModalEdit",
			node_value: "flowchart/node_value"
		}),
		ListOptions() {
			return {
				group: {
					name: "items",
					pull: "clone",
					put: false
				},
				sort: false,
				ghostClass: "ghostCustom",
				dragClass: "ghostCustom",
				chosenClass: "dragCustomClass",
				animation: 200
			}
		}
	},
	components: {
		clone,
		cloneAt,
		draggable,
		GridLayout: VueGridLayout.GridLayout,
		GridItem: VueGridLayout.GridItem
	},
	methods: {
		...mapActions({
			editModalEdit: "flowchart/editModalEdit",
			loadList: "builder/loadList",
			deleteCustomEL: "builder/deleteCustomEL",
			setCut: "builder/setCut"
		}),
		clone,
		closeEditor() {
			this.editModalEdit({ val: false, id: undefined })
		},
		async dblClick(e) {
			await this.setCut(this.clone(e))
			this.$notify({
				title: this.$t("copied-success"),

				position: "bottom-right"
			})
			// const temp = this.selected_node
			// temp.value[0].items.push(this.clone(e))
		}
	}
}
</script>
<style lang="scss">
@import "src/assets/scss/floating";
</style>
<style scoped></style>
